import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { SessionsService } from '../sessions/sessions.service';

@Injectable()
export class StatsResolver implements Resolve<any> {
  constructor(private router: Router, private sessions: SessionsService) {}
  resolve(): Observable<any> {
    return this.sessions.getAll().catch(() => {
      this.router.navigate(['/error'], { skipLocationChange: true });
      return Observable.of(false);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/stats.resolver.ts